import { Drawer, Segmented } from 'antd';
import { useUnit } from 'effector-react';
import { useState } from 'react';
import style from './MetricModal.module.css';
import {
  $activeCity,
  $language,
  $metricDetails,
  resetMetricDetailsEv,
} from '../../models/logicModel/index.js';
import un_descr_dict from '../../dictionaries/un_descr_dict.json';

function MetricModal() {
  const metricDetails = useUnit($metricDetails);
  const resetMetricDetails = useUnit(resetMetricDetailsEv);
  const activeCity = useUnit($activeCity);
  const [tab, setTab] = useState('un_info');
  const language = useUnit($language);

  const tabs = [
    {
      label: 'Риск для города',
      value: 'un_info',
    },
    {
      label: 'Методика расчета',
      value: 'metodology',
    },
  ];

  if (!metricDetails) return null;

  return (
    <Drawer open={!!metricDetails} onClose={resetMetricDetails} mask={false}>
      <Segmented options={tabs} value={tab} onChange={setTab} block />
      <div
        dangerouslySetInnerHTML={{
          __html: un_descr_dict[activeCity][metricDetails][tab][language],
        }}
      />
    </Drawer>
  );
}

export default MetricModal;
